import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import PageWrapper from './components/PageWrapper';
import myIcon from './assets/logo512.png';

const Login = () => {
  const { signInWithGoogle, signInWithEmail, signUpWithEmail, resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    setMessage('');
    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }
    try {
      await signInWithEmail(email, password);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleRegister = async () => {
    setError('');
    setMessage('');
    if (!email || !password || !confirmPassword) {
      setError('All fields are required.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    try {
      await signUpWithEmail(email, password);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async () => {
    if (googleLoading) return;
    setGoogleLoading(true);
    setError('');
    setMessage('');
    try {
      await signInWithGoogle();
    } catch (err) {
      setError("Google Sign-In failed: " + err.message);
    } finally {
      setGoogleLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setError('');
    setMessage('');
    if (!email) {
      setError('Please enter your email to reset your password.');
      return;
    }
    try {
      await resetPassword(email);
      setMessage('Password reset email sent.');
    } catch (err) {
      setError('Reset failed: ' + err.message);
    }
  };

  return (
    <PageWrapper>
      <div className="auth-shell">
        <div className="auth-hero">
          <img src={myIcon} alt="AllMyTunes logo" className="responsive-icon" />
          <div>
            <h1 className="auth-title">Welcome to AllMyTunes</h1>
            <p className="auth-subtitle">
              Build your tune library, track sessions, and keep notes in one place.
            </p>
          </div>
        </div>

        <div className="auth-card">
          <h2 style={{ margin: '0 0 8px', fontSize: '1.15rem' }}>
            {isRegistering ? 'Create your account' : 'Sign in to continue'}
          </h2>

          {error && <div className="auth-message auth-message-error">{error}</div>}
          {message && <div className="auth-message auth-message-success">{message}</div>}

          <button
            onClick={handleGoogleSignIn}
            className="btn-subtle search-control-btn auth-action-btn"
            disabled={googleLoading}
          >
            {googleLoading ? 'Signing in with Google...' : 'Sign in with Google'}
          </button>

          <hr className="settings-divider" />

          <input
            className="search-input auth-input"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <input
            className="search-input auth-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          {!isRegistering && (
            <div style={{ marginTop: '3px', textAlign: 'right' }}>
              <button
                className="btn-subtle search-control-btn"
                onClick={handleResetPassword}
                style={{ padding: '0 10px', fontSize: 'var(--ui-compact-font)' }}
              >
                Forgot password?
              </button>
            </div>
          )}

          {isRegistering && (
            <input
              className="search-input auth-input"
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
            />
          )}

          <button
            onClick={isRegistering ? handleRegister : handleLogin}
            className="btn-subtle search-control-btn auth-action-btn"
            style={{ marginTop: '8px' }}
          >
            {isRegistering ? 'Create Account' : 'Login with Email'}
          </button>

          <div style={{ marginTop: '14px', textAlign: 'center' }}>
            <button
              onClick={() => {
                setIsRegistering(!isRegistering);
                setError('');
                setMessage('');
                setEmail('');
                setPassword('');
                setConfirmPassword('');
              }}
              className="btn-subtle search-control-btn auth-action-btn"
            >
              {isRegistering ? '← Back to Login' : 'Register New Account →'}
            </button>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Login;
